import { render, staticRenderFns } from "./CartAttributes.vue?vue&type=template&id=b0dfdfe6&"
import script from "./CartAttributes.vue?vue&type=script&lang=js&"
export * from "./CartAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0dfdfe6')) {
      api.createRecord('b0dfdfe6', component.options)
    } else {
      api.reload('b0dfdfe6', component.options)
    }
    module.hot.accept("./CartAttributes.vue?vue&type=template&id=b0dfdfe6&", function () {
      api.rerender('b0dfdfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/CartAttributes.vue"
export default component.exports